import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useResource } from 'app/common/api';
import { TPageable } from 'app/common/constraints/core/constraints';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';

import { TEmployee } from '../../core/employee';
import { TEmployeeConstraints } from '../../core/employee-constraints';
import { getEmployeesRequest } from '../../requests';
import { UiSelectEmployees } from '../../ui/ui-select-employees/ui-select-employees';

type EmployeeItem = Pick<TEmployee, 'id' | 'name'>;

type AvailableEmployeesProps = {
  value?: EmployeeItem[];
  onChange?: (empl: EmployeeItem[]) => void;
  displayLoader?: boolean;
};

export const AvailableEmployees = observer(
  ({ value = [], onChange }: AvailableEmployeesProps) => {
    const [items, setItems] = useState<TEmployee[]>([]);
    const errorNotify = usePageNotify();

    const getEmployeesResource = useResource<
      TEmployeeConstraints,
      TPageable<TEmployee[]>
    >({
      request: getEmployeesRequest,
      errorNotify: errorNotify,
      onDone(result) {
        const employees = result.content;
        setItems(employees);
      },
    });

    const handleChange = (values: EmployeeItem[]) => {
      onChange && onChange(values);
    };

    const isLoading = getEmployeesResource.isLoading;

    useEffect(() => {
      getEmployeesResource.send({ filter: null, sorting: [] });
    }, []);

    return (
      <UiSelectEmployees
        loading={isLoading}
        items={items}
        onChange={handleChange}
        value={value}
      />
    );
  }
);
